<script setup>
const props = defineProps({
  // 性别
  gender: {
    required: true,
  },
  // 是否缩小图
  isSmall: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div v-if="!props.isSmall">
    <img v-if="props.gender === 1 || props.gender === '男'" style="width: 16px;height: 16px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_male.svg">
    <img v-else-if="props.gender === 2 || props.gender === '女'" style="width: 16px;height: 16px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_female.svg">
    <div v-else>—</div>
  </div>
  <div v-else>
    <img v-if="props.gender === 1 || props.gender === '男'" style="width: 13px;height: 13px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/small_male.svg">
    <img v-else-if="props.gender === 2 || props.gender === '女'" style="width: 13px;height: 13px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/small_female.svg">
    <div v-else>—</div>
  </div>
</template>

<style scoped>

</style>
